import moment from 'moment'

export default {
  //
  // Map
  //
  MAP_CLEAR (state) {
    state.map.searching = false
    state.map.result = null
    state.map.message = null
    state.map.filters = {
      date: new Date(),
      idAgent: null,
      idRonde: null,
    }
  },
  MAP_SEARCHING (state) {
    state.map.searching = true
  },
  RONDES_SEARCHING (state) {
    state.rondes.searching = true
  },
  MAP_RESULT (state, result) {
    state.map.agents = []
    state.map.rondes = []
    console.log('mutation :: ', result.elements)

    result.elements.forEach(function (tournee) {
      let agent = state.agents.data.find(a => a.id === tournee.agent_id)
      agent.fullName = agent.prenom + ' ' + agent.nom
      let ronde = state.rondes.data.find(r => r.id === tournee.ronde_id)
      ronde.agent_id = agent.id
      state.map.agents.push(agent)
      state.map.rondes.push(ronde)
    })

    console.log('state rondes of the day :: ', state.map.rondes)
    console.log('state agents of the day :: ', state.map.agents)

    /*     state.map.message = null
        state.map.searching = false
        state.map.result = res
        if (res.geopassages && res.geopassages.length === 0) {
          state.map.message = {
            text: 'Aucun point GPS collecté pour cette tournée',
            type: 'warning',
          }
        } */
  },
  REPORTING_RESULT (state, result) {
    state.reporting.agents = []
    state.reporting.rondes = []

    result.elements.forEach(function (tournee) {
      let agent = Object.assign({}, state.agents.data.find(a => a.id === tournee.agent_id))
      agent.fullName = agent.prenom + ' ' + agent.nom

      let ronde = Object.assign({}, state.rondes.data.find(r => r.id === tournee.ronde_id))
      ronde.agent_id = agent.id
      agent.ronde_id = ronde.id

      state.reporting.agents.push(agent)
      state.reporting.rondes.push(ronde)

    })


    const uniqueRondesSet = new Set()
    state.reporting.rondes = state.reporting.rondes.filter(ronde => !uniqueRondesSet.has(ronde.id) && uniqueRondesSet.add(ronde.id))

    console.log("-state.reporting.agents :: " , state.reporting.agents)
    state.reporting.searching = false

  },

  GEOPASSAGES_RESULT (state, result) {

    console.log('mutation GEO :: ', result.elements[0])

    state.map.message = null
    state.map.searching = false
    state.map.result = result.elements[0]
    if (state.map.result.remonteeGPSs && state.map.result.remonteeGPSs.length === 0) {
      console.log('aywaaaa zero')
      state.map.message = {
        text: 'Aucun point GPS collecté pour cette tournée',
        type: 'warning',
      }
    }
  },
  MAP_MESSAGE (state, message) {
    state.map.message = message
    state.map.searching = false
    state.map.result = null
  },
  CLEAR_MAP_MESSAGE (state) {
    state.map.message = null
  },
  //
  // Agents
  //
  ADD_AGENT (state, agent) {
    agent.listRondesReferents = []
    agent.listRondesAffectees = []
    const indexExisting = state.agents.data.findIndex((a) => {
      return a.meta.id === agent.meta.id
    })
    if (indexExisting >= 0) {
      state.agents.data.splice(indexExisting, 1)
    }
    state.agents.data.push(agent)
    state.showProfilDiv = true
  },
  AGENT_MESSAGE (state, message) {
    state.agents.message = message
  },
  DISPLAY_AGENT_CREATE_BOX (state) {
    state.agents.isActiveCreatedAgentModal = true
    state.showProfilDiv = true
  },
  HIDE_AGENT_CREATE_BOX (state) {
    state.agents.isActiveCreatedAgentModal = false
  },
  CLEAR_AGENTS_MESSAGE (state) {
    state.agents.message = null
  },
  CREATE_AGENT (state, agentCreated) {
    console.log('mutation :: ', agentCreated)
    state.agents.list.push(agentCreated)
    state.agents.isActiveCreatedAgentModal = false
  },
  UPDATE_AGENT (state, agentUpdated) {
    state.agents.list.forEach(function (agent) {
      if (agent.id === agentUpdated.id) {
        agent.prenom = agentUpdated.prenom
        agent.nom = agentUpdated.nom
        agent.actif = agentUpdated.actif
        agent.profile = agentUpdated.profile
      }
    })
  },
  AGENT_DATA_RONDES_RESULT (state, {agentId, listRondesReferents, listRondesAffectees}) {
    var agent = state.agents.data.find(function (a) {
      return a.meta.id === agentId
    })
    if (agent) {
      agent.listRondesAffectees = listRondesAffectees
      agent.listRondesReferents = listRondesReferents
    }
  },
  AGENT_DATA_TOURNEES_RESULT (state, {agentId, rondesEffectuees}) {
    var listRondesEffectuees = rondesEffectuees.map(function (rondeId) {
      return state.rondes.data.find(function (r) {
        return r.meta.id === rondeId
      }).nom
    })
    var agent = state.agents.data.find(function (a) {
      return a.meta.id === agentId
    })
    if (agent) {
      agent.listRondesEffectuees = listRondesEffectuees
    }
  },
  //
  // Agents - change password
  //
  SHOW_AGENT_PASSWORD_CHANGE_MODAL (state) {
    state.agents.passwordChangeModal.visible = true
    state.agents.passwordChangeModal.loading = false
    state.agents.passwordChangeModal.canOnlyExitModal = false
    state.agents.passwordChangeModal.message = null
  },
  HIDE_AGENT_PASSWORD_CHANGE_MODAL (state) {
    state.agents.passwordChangeModal.visible = false
  },
  PASSWORD_CHANGE_LOADING (state) {
    state.agents.passwordChangeModal.loading = true
    state.agents.passwordChangeModal.message = null
  },
  PASSWORD_CHANGE_FINISHED (state, {message, canOnlyExitModal, ronde}) {
    state.agents.passwordChangeModal.loading = false
    state.agents.passwordChangeModal.message = message
    state.agents.passwordChangeModal.canOnlyExitModal = canOnlyExitModal
  },
  //
  // Rondes
  //
  RONDES_RESULT (state, rondes) {
    console.log('mutation rondes => ', rondes.elements)
    _.each(rondes.elements, function (ronde) {
      ronde.loginRef = ronde.agentReferent_id ? state.agents.data.find((agent) => agent.id === ronde.agentReferent_id).login : '-'
      ronde.loginPla = ronde.agentPlanifie_id ? state.agents.data.find((agent) => agent.id === ronde.agentPlanifie_id).login : '-'
    })
    state.rondes.data = rondes.elements
    state.rondes.searching = false
  },
  RONDE_RESULT (state, ronde) {
    console.log('ronde ==> ', ronde)
    state.ronde.data = ronde
  },
  AGENTS_RESULT (state, agents) {
    console.log('mutation agents => ', agents)
    state.agents.data = agents.elements
    console.log('agents => ', state.agents.data)
  },
  AGENTS_LIST_RESULT (state, agents) {
    console.log('mutation agents list => ', agents)
    state.agents.list = agents.elements
    console.log('agents => ', state.agents.list)
  },
  AGENTS_CHANGE_PASSWORD (state, {message, updated}) {
    state.agents.passwordChangeModal.message = message
    state.agents.passwordChangeModal.canOnlyExitModal = updated
  },
  ADMINS_RESULT (state, admins) {
    state.administrators.data = admins.elements
  },
  ADRESSES_RESULT (state, adresses) {
    state.adresses.data = adresses.elements
    console.log('adresses mutation => ', state.adresses.data)
    state.rondes.searching = false
  },
  RONDE_LOADING_FOR_SWITCHING_INTERVENTIONS_POSITIONS (state) {
    state.ronde.loadingInterventionsPositions = true
  },
  RONDE_INTERVENTIONS_SWITCHED (state, ronde) {
    console.log('state ronde => ', ronde.interventions)
    /*     ronde.interventions.forEach(function (i, index) {
          i.order = index
        }) */

    state.ronde.data.interventions = ronde.interventions

    state.ronde.loadingInterventionsPositions = false
  },
  RONDE_INTERVENTIONS_MESSAGE (state, message) {
    state.rondes.interventionsMessage = message
    state.rondes.loadingInterventionsPositions = false
  },
  SHOW_DETAIL_MODAL_FOR_INTERVENTION (state, intervention) {
    state.rondes.interventionDetailModal.intervention = intervention
  },
  HIDE_DETAIL_MODAL_FOR_INTERVENTION (state) {
    state.rondes.interventionDetailModal.intervention = null
    state.rondes.interventionDetailModal.message = null
    state.rondes.interventionDetailModal.canOnlyExitModal = false
  },
  SHOW_DETAIL_MODAL_FOR_DEBUT_FIN_JALON (state, intervention) {
    state.rondes.deleteDebutFinJalonModal.intervention = intervention
    state.rondes.deleteDebutFinJalonModal.visible = true
  },
  HIDE_DETAIL_MODAL_FOR_DEBUT_FIN_JALON (state) {
    state.rondes.deleteDebutFinJalonModal.intervention = null
    state.rondes.deleteDebutFinJalonModal.visible = false
  },
  DEBUT_FIN_JALON_REMOVED (state, {message}) {
    state.rondes.deleteDebutFinJalonModal.message = message
    state.rondes.deleteDebutFinJalonModal.visible = false
    state.rondes.deleteDebutFinJalonModal.intervention = null
  },
  DETAIL_MODAL_FOR_INTERVENTION_LOADING (state) {
    state.rondes.interventionDetailModal.loading = true
  },
  DETAIL_MODAL_FOR_INTERVENTION_MESSAGE (state, message) {
    state.rondes.interventionDetailModal.loading = false
    state.rondes.interventionDetailModal.message = message
  },
  INTERVENTION_REMOVED (state, {message}) {
    state.rondes.interventionDetailModal.message = message
    state.rondes.interventionDetailModal.loading = false
    state.rondes.interventionDetailModal.canOnlyExitModal = true
  },
  INTERVENTION_AND_ADRESSE_UPDATED (state, {message, newIntervention, newAdresse}) {
    state.ronde.data.interventions.forEach(function (intervention) {
      if (intervention.id === newIntervention.id) {
        intervention.sortieBacs = newIntervention.sortieBacs
      }
      if (intervention.adresse && intervention.adresse.id === newIntervention.adresse.id) {
        intervention.adresse = newAdresse
      }
    })

    state.rondes.interventionDetailModal.message = message
    state.rondes.interventionDetailModal.loading = false
    state.rondes.interventionDetailModal.canOnlyExitModal = true
  },
  INTERVENTION_UPDATED (state, {message, newIntervention}) {

    /*     state.ronde.data.interventions.forEach(function (intervention) {
          if (intervention.id === newIntervention.id) {
            intervention.sortieBacs = newIntervention.sortieBacs
          }
        }) */

    state.rondes.interventionDetailModal.message = message
    state.rondes.interventionDetailModal.loading = false
    state.rondes.interventionDetailModal.canOnlyExitModal = false
  },
  SHOW_MODAL_FOR_AJOUT_INTERVENTION (state) {
    state.rondes.ajoutInterventionModal.visible = true
    state.rondes.ajoutInterventionModal.loading = false
  },
  HIDE_MODAL_FOR_AJOUT_INTERVENTION (state) {
    state.rondes.ajoutInterventionModal.visible = false
    state.rondes.ajoutInterventionModal.loading = false
    state.rondes.ajoutInterventionModal.message = null
    state.rondes.ajoutInterventionModal.canOnlyExitModal = false
    state.rondes.ajoutInterventionModal.searchResults = []
  },
  AJOUT_INTERVENTION_MODAL_SEARCHING (state) {
    state.rondes.ajoutInterventionModal.searching = true
  },
  AJOUT_INTERVENTION_MODAL_SEARCH_RESULT (state, searchResults) {
    console.log('staaate ::: ', searchResults)
    state.rondes.ajoutInterventionModal.searching = false
    state.rondes.ajoutInterventionModal.searchResults = searchResults
  },
  AJOUT_INTERVENTION_MODAL_LOADING (state) {
    state.rondes.ajoutInterventionModal.loading = true
  },
  AJOUT_INTERVENTION_MODAL_MESSAGE (state, {message, canOnlyExitModal}) {
    state.rondes.ajoutInterventionModal.loading = false
    state.rondes.ajoutInterventionModal.message = message
    state.rondes.ajoutInterventionModal.canOnlyExitModal = canOnlyExitModal
    console.log('aya salam salamo3alikom')
  },
  AJOUT_DEBUT_OU_FIN_JALON (state, {idRonde, interventions}) {
    state.rondes.ajoutInterventionModal.loading = false
    state.rondes.data.forEach(function (ronde) {
      if (ronde.meta.id === idRonde) {
        ronde.interventions = interventions
      }
    })
  },
  SHOW_RONDE_UPDATE_MODAL (state) {
    state.rondes.updateModal.visible = true
    state.rondes.updateModal.loading = false
    state.rondes.updateModal.canOnlyExitModal = false
    state.rondes.updateModal.message = null
  },
  SHOW_RONDE_IMPORT_MODAL (state) {
    state.rondes.importModal.visible = true
    state.rondes.importModal.loading = false
    state.rondes.importModal.canOnlyExitModal = false
    state.rondes.importModal.message = null
  },
  SHOW_RONDE_CREATE_MODAL (state) {
    state.rondes.createModal.visible = true
    state.rondes.createModal.loading = false
    state.rondes.createModal.canOnlyExitModal = false
    state.rondes.createModal.message = null
  },
  HIDE_RONDE_UPDATE_MODAL (state) {
    state.rondes.updateModal.visible = false
  },
  HIDE_RONDE_CREATE_MODAL (state) {
    state.rondes.createModal.visible = false
  },
  UPDATE_RONDE_LOADING (state) {
    state.rondes.updateModal.loading = true
    state.rondes.updateModal.message = null
  },
  CREATE_RONDE_LOADING (state) {
    state.rondes.createModal.loading = true
    state.rondes.createModal.message = null
  },
  UPDATE_RONDE_FINISHED (state, {message, canOnlyExitModal, newRonde}) {
    state.rondes.updateModal.loading = false
    state.rondes.updateModal.message = message
    state.rondes.updateModal.canOnlyExitModal = canOnlyExitModal
    console.log('mutation => ', newRonde)
    if (newRonde) {
      console.log('in if')
      state.rondes.data.forEach(function (stateRonde) {
        if (stateRonde.id === newRonde.id) {
          console.log('in if if')
          stateRonde.nom = newRonde.nom
          stateRonde.numero = newRonde.numero
          stateRonde.agentReferent_id = newRonde.agentReferent_id
          stateRonde.agentPlanifie_id = newRonde.agentPlanifie_id
          stateRonde.loginRef = newRonde.agentReferent_id ? state.agents.data.find((agent) => agent.id === newRonde.agentReferent_id).login : '-'
          stateRonde.loginPla = newRonde.agentPlanifie_id ? state.agents.data.find((agent) => agent.id === newRonde.agentPlanifie_id).login : '-'
        }
      })
    }

    console.log('after => ', state.rondes.data)
  },
  CREATE_RONDE_FINISHED (state, {message, canOnlyExitModal, newRonde}) {
    state.rondes.createModal.loading = false
    state.rondes.createModal.message = message
    state.rondes.createModal.canOnlyExitModal = canOnlyExitModal
    if (newRonde) {
      state.rondes.data.unshift(newRonde)
    }
  },
  CLEAR_RONDE_MESSAGE (state) {
    state.rondes.message = null
  },
  SHOW_RONDE_ERROR_MESSAGE (state, message) {
    state.rondes.importModal.message = message
  },
  RONDES_IMPORT_MESSAGE (state, {message}) {
    state.rondes.importModal.message = message
    state.rondes.searching = false
    console.log("state.rondes.importModal.message :: " , state.rondes.importModal.message)
  },
  CLEAR_RONDES_IMPORT_MESSAGE (state) {
    state.rondes.importModal.message = null
  },
  //
  // Login stuff
  //
  LOGIN_LOADING (state) {
    state.login.message = null
    state.login.loading = true
    state.login.loggedIn = false
  },
  LOGIN_MESSAGE (state, message) {
    state.login.message = message
    state.login.loading = false
  },
  LOGIN_SUCCESS (state, data) {
    state.login.loading = false
    state.login.loggedIn = true
    state.login.idUser = data.id
    //state.login.data = data
  },
  CLEAR_LOGIN_MESSAGE (state) {
    state.login.message = null
  },
  LOGOUT (state) {
    localStorage.removeItem('TOKEN');
    state.login.loggedIn = false
    state.login.loading = false
    localStorage.clear()
  },

  // Reset Password

  RESET_PASSWORD_MESSAGE (state, message) {
    localStorage.clear()
    console.log("state : " , state)
    state.resetPassword.message = message
  },

  CLEAR_RESET_PASSWORD_MESSAGE (state) {
    state.resetPassword.message = null
  },
  //
  // Administrateurs
  //
  CLEAR_ALL_ADMINISTRATORS (state) {
    state.administrators.data = []
    state.administrators.message = null
  },
  ADD_ADMINISTRATOR (state, admin) {
    state.administrators.data.push(admin)
    state.showProfilDiv = false
  },
  ADMINISTRATOR_MESSAGE (state, message) {
    state.administrators.message = message
  },
  CLEAR_ADMINISTRATORS_MESSAGE (state) {
    state.administrators.message = null
  },
  CREATE_ADMINISTRATOR (state, createdAdministrator) {
    console.log('createdAdministrator :::: ', createdAdministrator)
    state.administrators.data.push(createdAdministrator)
    console.log('state of administrators ::: ', state.administrators.data)
    state.administrators.isActiveCreatedAdminModal = false
  },
  UPDATE_ADMINISTRATOR (state, adminUpdated) {
    state.administrators.data.forEach(function (admin) {
      if (admin.id === adminUpdated.id) {
        admin.nom = adminUpdated.nom
        admin.prenom = adminUpdated.prenom
        admin.actif = adminUpdated.actif
        admin.email = adminUpdated.email
      }
    })
  },
  DISPLAY_ADMINISTRATOR_CREATE_BOX (state) {
    state.administrators.isActiveCreatedAdminModal = true
    state.showProfilDiv = false
  },
  HIDE_ADMINISTRATOR_CREATE_BOX (state) {
    state.administrators.isActiveCreatedAdminModal = false
  },
  //
  // Administrators - change password
  //
  SHOW_ADMINISTRATOR_PASSWORD_CHANGE_MODAL (state) {
    state.administrators.passwordChangeModal.visible = true
    state.administrators.passwordChangeModal.loading = false
    state.administrators.passwordChangeModal.canOnlyExitModal = false
    state.administrators.passwordChangeModal.message = null
  },
  HIDE_ADMINISTRATOR_PASSWORD_CHANGE_MODAL (state) {
    state.administrators.passwordChangeModal.visible = false
  },
  ADMINISTRATOR_PASSWORD_CHANGE_LOADING (state) {
    state.administrators.passwordChangeModal.loading = true
    state.administrators.passwordChangeModal.message = null
  },
  ADMINISTRATOR_PASSWORD_CHANGE_FINISHED (state, {message, canOnlyExitModal}) {
    state.administrators.passwordChangeModal.loading = false
    state.administrators.passwordChangeModal.message = message
    state.administrators.passwordChangeModal.canOnlyExitModal = canOnlyExitModal
  },
  ADMINS_CHANGE_PASSWORD (state, {message, updated}) {
    state.administrators.passwordChangeModal.message = message
    state.administrators.passwordChangeModal.canOnlyExitModal = updated
  },

  // Anomalie

  ANOMALIES_FILTER_RESULT (state, anomalies) {
    state.anomalies.filter.data = anomalies
  },

  ANOMALIES_REPORTING_RESULT (state, anomalies) {
    console.log('mutation anomalies :: ', anomalies)
    state.anomalies.reporting = anomalies
  },

  ANOMALIE_FETCH_IMAGE (state, anomalieImage) {
    state.anomalies.anomalie_image = anomalieImage.data
  },
  //
  // REPORTING
  //
  REPORTING_CLEAR_FILTERS (state) {
    state.reporting.agentsIds = null
    state.reporting.rondesIds = null
    state.reporting.fromFilterDate = new Date()
    state.reporting.toFilterDate = new Date()
    state.reporting.searching = false
    state.reporting.result = null
    state.reporting.message = null
  },
  SHOW_REPORTING_LOADING (state) {
    state.reporting.searching = true
  },
  HIDE_REPORTING_LOADING (state) {
    state.reporting.searching = false
  },
  REPORTING_MESSAGE (state, message) {
    state.reporting.message = message
  },
  CLEAR_REPORTING_MESSAGE (state) {
    state.reporting.message = null
  },
  REPORTING_DATA_RESULT (state, data) {
    let reportingData = []
    console.log('mutation reporting data :: ', data)
    data.elements.forEach(function (tournee) {
      if (tournee.startedAt) {
        let value = {}
        value.date = moment(tournee.startedAt).format('DD/MM/YYYY')
        value.heure = moment(tournee.startedAt).format('HH[h]mm')
        value.agent = tournee.agentFirstName + ' ' + tournee.agentLastName
        value.rondeSC = tournee.nomRonde
        value.commune = 'LYON'
        value.nRue = '-'
        value.adresse = '-'
        value.anomalie = '-'
        value.collecte = '-'
        value.topAction = 'Début de service'
        value.nRonde = tournee.numRonde
        console.log("tournnee :::: " , tournee)
        value.coordGps = tournee.remonteeGPSs.length > 0 ?  tournee.remonteeGPSs[0].lat + ' , ' + tournee.remonteeGPSs[0].lon : '-'
        value.qualities
        reportingData.push(value)
      }
      if (tournee.totalPause && tournee.totalPause > 1) {
        let value = {}
        value.date = moment(tournee.date).format('DD/MM/YYYY')
        value.heure = tournee.totalPause >= 6000 ?  formatPause(tournee.totalPause) : '-'
        console.log("value.heure :: " , value.heure)
        value.agent = tournee.agentFirstName + ' ' + tournee.agentLastName
        value.rondeSC = tournee.nomRonde
        value.commune = 'LYON'
        value.nRue = '-'
        value.adresse = '-'
        value.anomalie = '-'
        value.collecte = '-'
        value.topAction = 'PAUSE'
        value.nRonde = tournee.numRonde
        value.coordGps = '-'
        reportingData.push(value)
      }
      if (tournee.anomalies.length > 0) {
        tournee.anomalies.forEach(function (anomalie) {
          let value = {}
          value.date = moment(anomalie.date).format('DD/MM/YYYY')
          value.heure = moment(anomalie.date).format('HH[h]mm')
          value.agent = tournee.agentFirstName + ' ' + tournee.agentLastName
          value.rondeSC = tournee.nomRonde
          value.commune = 'LYON'
          value.nRue = anomalie.addresse.replace(/^\D*(\d+).*/, '$1');
          value.adresse = anomalie.addresse.replace(/^\d+/, '');
          value.anomalie = anomalie.type
          value.collecte = anomalie.bacPresent ? 'OUI' : 'NON'
          value.topAction = 'ANOMALIE'
          value.nRonde = tournee.numRonde
          value.coordGps = '-'
          reportingData.push(value)
        })
      }
      if (tournee.finishedAt) {
        let value = {}
        value.date = moment(tournee.finishedAt).format('DD/MM/YYYY')
        value.heure = moment(tournee.finishedAt).format('HH[h]mm')
        value.agent = tournee.agentFirstName + ' ' + tournee.agentLastName
        value.rondeSC = tournee.nomRonde
        value.commune = 'LYON'
        value.nRue = '-'
        value.adresse = '-'
        value.anomalie = '-'
        value.collecte = '-'
        value.topAction = 'Fin de service'
        value.nRonde = tournee.numRonde
        value.coordGps = tournee.remonteeGPSs.length > 0 ? tournee.remonteeGPSs[tournee.remonteeGPSs.length - 1].lat + ' , ' + tournee.remonteeGPSs[tournee.remonteeGPSs.length - 1].lon : '-'
        reportingData.push(value)
      }
    })

    state.reporting.result = reportingData
  },

  //
  // Jalons
  //

  JALONS_RESULT (state, jalons) {
    console.log('mutation jalons => ', jalons.elements)
    state.jalons.data = jalons.elements
    console.log('state jalons => ', state.jalons.data)
  },



}

function formatPause(time) {
  // Calculate hours, minutes, and seconds
  const hours = Math.floor(time / (1000 * 60 * 60));
  const minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((time % (1000 * 60)) / 1000);

  // Format the result as "hh:mm:ss"
  return `${pad(hours)}h${pad(minutes)}m${pad(seconds)}s`;
}

function pad(value) {
  return value < 10 ? `0${value}` : value;
}

function convertDuration (durationInMs) {
  var dms = parseInt(durationInMs, 10)
  var secNum = Math.ceil(dms / 1000)
  var hours = Math.floor(secNum / 3600)
  var minutes = Math.floor((secNum - (hours * 3600)) / 60)
  var duration = ''
  if (minutes < 10) { minutes = '0' + minutes }
  if (hours !== '00' && hours !== '0') {
    duration = hours + 'H'
  }
  if (minutes !== '00') {
    duration = duration + minutes + 'm'
  }
  if (_.includes(duration, 'NaN')) {
    return '-'
  } else if (duration === '0H') {
    return '-'
  } else {
    return duration
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js